import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy, ElementRef } from '@angular/core';
// import { CommunicationService } from '../../services/communication.service';
import { Renderer2, Inject } from '@angular/core';
// import { DOCUMENT } from '@angular/platform-browser';
// import { UtilityService } from 'src/app/services/utility.service';
import { Subscription } from 'rxjs';
import { Store } from 'src/app/core/store/store';
import { CommunicationService } from 'src/app/shared/services/communication.service';
import { UtilityService } from 'src/app/shared/utils/utility.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { data } from 'jquery';


// import { Store } from 'store';

declare var fbq;
declare var TimeMe;
 

@Component({
  selector: 'app-exercise-navigation-bar',
  templateUrl: './exercise-navigation-bar.component.html',
  styleUrls: ['./exercise-navigation-bar.component.css']
})
export class ExerciseNavigationBarComponent implements OnInit, AfterViewInit, OnDestroy {

  courseTitle;
  exerciseTitle;
  @Input() questionAttempted: boolean = false;;
  @Input() questionChecked: boolean = false;;
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() id: string;
  @Input() questionAttemptedLeast: boolean = false;;

  @Output() onReview = new EventEmitter<Boolean>(false);
  @Output() onNext = new EventEmitter<Boolean>(false);
  @Output() onSubmit = new EventEmitter<Boolean>(false);
  isLastQuestion: boolean = false;
  currentUserCourse:any;
  timeSpentPerQuestion = {};
  private subscription:Subscription;
  @Input() exerciseTimetrackingdata;
  @Input() index;
  activationInfo: any;

  constructor(private communicationService: CommunicationService,  private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document, private utilityService: UtilityService, private store: Store,
    private commonService : CommonService,private questionNumber: ElementRef) { }

  ngOnInit() {
    this.communicationService.unAttemptedQuestions.subscribe(res => {
      if (res.length == 1) {
        this.isLastQuestion = res[0].id == this.id;
      } else if (res.length == 0){
        this.isLastQuestion = true;
      }
      else{
        this.isLastQuestion = false;
      } 
    });
  
    this.subscription = this.store.select<any>('qsResponse').subscribe(id => {
      if((id == this.id) && !this.isLastIndex && this.questionAttempted) {
        this.next();
        this.store.set('qsResponse', null);
      }
    });
    this.store.select('currentUserCourse').subscribe((data: any) => {
      this.currentUserCourse = data;
    });
    if(this.currentUserCourse && this.currentUserCourse.type == 'COURSE'){
      this.setCoursedataTimespent(this.currentUserCourse);
    } else {
      this.timeSpentPerQuestion = {...this.exerciseTimetrackingdata}
      this.timeSpentPerQuestion['pageType'] = 'QUESTION';
    }
    
    TimeMe.initialize({
	    currentPageName: 'Question Page', // current page
    });
    TimeMe.startTimer();
  }

  setCoursedataTimespent(data){
    this.timeSpentPerQuestion['eventType'] = "PROG-COURSE";
    this.timeSpentPerQuestion['programDashboardId'] = data['programDashboardId'];
    this.timeSpentPerQuestion['programActivationId'] = data['programActivationId'];
    this.timeSpentPerQuestion['organization'] = data['organization'];
    this.timeSpentPerQuestion['courseId'] = data['courseId'];
    this.timeSpentPerQuestion['courseName'] = data['courseName'];
    this.timeSpentPerQuestion['templateName'] = data['templateName'];
    this.timeSpentPerQuestion['blockType'] = 'QUESTION';
    this.timeSpentPerQuestion['moduleNumber'] = +(data['lastVisitedContentModuleName'].split(":")[0].substring(7));
    this.timeSpentPerQuestion['moduleName'] = data['lastVisitedContentModuleName'];
    this.timeSpentPerQuestion['courseExerciseId'] = data['lastVisitedContent'];
    this.timeSpentPerQuestion['courseExerciseTemplateName'] = data['lastVisitedContentTitle'];
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.utilityService.TrackData.subscribe(res => {
        this.courseTitle = res['cTitle'];
        this.exerciseTitle = res['eTitle'];
      });
      
    }, 2000)
  }

  review() {
    this.onReview.emit(true);
  }

  next() {
    this.setTimetrackingData();
    TimeMe.initialize();
    TimeMe.startTimer(); 
    this.onNext.emit(true);
  }

  submit() {
    if(this.courseTitle == 'EMBRACING CHANGE' && this.exerciseTitle == "Practice Exercise 3") {
        fbq('track', 'EC_half')
    }

    if(this.courseTitle == 'EMBRACING CHANGE' && this.exerciseTitle == "Touchstone 2") {

      fbq('track', 'EC_Complete')

    }
    this.setTimetrackingData();
    this.onSubmit.emit(true);
  }

 get isLastIndex(){
   return this.communicationService.getLastQuestionId() == this.id;
 }

 setTimetrackingData(){
   if(this.timeSpentPerQuestion['eventType'] == 'PROG-COURSE'){
    this.timeSpentPerQuestion['moduleQuestionNumber'] = +(document.querySelector('.top-panel-pagination__listitem.active > a').innerHTML);
   } else{
    this.timeSpentPerQuestion['questionNumber'] = +(document.querySelector('.top-panel-pagination__listitem.active > a').innerHTML);
   }  

  if(TimeMe.getTimeOnCurrentPageInSeconds() > 900){
    this.timeSpentPerQuestion['spentTime'] = 900;  
  } else {
    this.timeSpentPerQuestion['spentTime'] = TimeMe.getTimeOnCurrentPageInSeconds();
  }
  this.commonService.saveTimespentonPages(this.timeSpentPerQuestion).subscribe(resp => {
  })
  TimeMe.resetAllRecordedPageTimes();
 }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

}
